/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Drop } from './Drop';
import {
    DropFromJSON,
    DropFromJSONTyped,
    DropToJSON,
    DropToJSONTyped,
} from './Drop';

/**
 * 
 * @export
 * @interface GetDropsResponse
 */
export interface GetDropsResponse {
    /**
     * 
     * @type {Array<Drop>}
     * @memberof GetDropsResponse
     */
    drops: Array<Drop>;
    /**
     * 
     * @type {number}
     * @memberof GetDropsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetDropsResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof GetDropsResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the GetDropsResponse interface.
 */
export function instanceOfGetDropsResponse(value: object): value is GetDropsResponse {
    if (!('drops' in value) || value['drops'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function GetDropsResponseFromJSON(json: any): GetDropsResponse {
    return GetDropsResponseFromJSONTyped(json, false);
}

export function GetDropsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDropsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'drops': ((json['drops'] as Array<any>).map(DropFromJSON)),
        'page': json['page'],
        'pageSize': json['pageSize'],
        'totalCount': json['totalCount'],
    };
}

export function GetDropsResponseToJSON(json: any): GetDropsResponse {
    return GetDropsResponseToJSONTyped(json, false);
}

export function GetDropsResponseToJSONTyped(value?: GetDropsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'drops': ((value['drops'] as Array<any>).map(DropToJSON)),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'totalCount': value['totalCount'],
    };
}

